<template>
  <div class="textarea" :class="{ error: error, req, val: state.isVal }">
    <textarea
      :name="name"
      :id="id"
      :value="value"
      @input="updateValue"
      @blur="updateState"
      :placeholder="placeholder"
    />
  </div>
</template>

<script lang="ts">
import { SetupContext, reactive, watch, onMounted } from 'vue'

export default {
  name: 'InputTextarea',

  props: {
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    req: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any, context: SetupContext) {
    const updateValue = (e: any) => {
      context.emit('call-input-change', e.target.value)
    }
    const state = reactive({
      isVal: false
    })

    const updateState = (e: any) => {
      state.isVal = false
      if (e.target.value && !props.error) {
        state.isVal = true
      }
    }

    onMounted(() => {
      if (props.value && !props.error) {
        state.isVal = true
      }
    })

    watch(
      () => props.value,
      () => {
        if (props.value) {
          state.isVal = true
        }
      }
    )
    return {
      updateValue,
      state,
      updateState
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.textarea {
  display: block;
  width: 100%;
  height: auto;
  min-height: 110px;
  padding: 0 10px;
  background-color: var.$color-white;
  border: 1px solid var.$color-border-gray;
  border-radius: 10px;
  box-shadow: 0 6px 9px rgba(0, 0, 0, 0.08);
  color: inherit;

  textarea {
    width: 114.285%;
    height: 100%;
    min-height: 110px;
    font-size: 1.6rem;
    transform: scale(0.875);
    transform-origin: left center;
    &::placeholder {
      color: #c6c6c6;
    }
  }
  &.req {
    background-color: #e7f8f6;
    &.val {
      background-color: transparent;
    }
  }
  &.error {
    border-color: var.$color-red;
  }
}
</style>
